import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { userSettingsQueryKeys } from '../constants'

export const useGetProfilePictureQuery = () => {
  const handleQuery = async () => {
    const config = {
      method: 'get',
      responseType: 'blob'
    }

    const { data } = await api('/api/v2/me/avatar', config)

    if (data.size === 0) {
      return null
    }

    const base64Image = await new Promise((resolve) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.readAsDataURL(data)
    })

    return base64Image
  }

  return useQuery({
    queryKey: [userSettingsQueryKeys.USER_PROFILE_PICTURE],
    queryFn: handleQuery
  })
}
